import { api } from '../../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../../shared/api/genexus-query';
import type { CrudApi } from '../../../shared/api/crud-hooks';
import type { DataTableQuery } from '../../../shared/components/DataTable';
import type { ImpostoDto, ImpostoInput, ImpostoListItem } from './types';

const BASE = '/v1/taxes';

export const impostosApi: CrudApi<ImpostoListItem, ImpostoDto, ImpostoInput> = {
  async list(query: DataTableQuery): Promise<ListEnvelope<ImpostoListItem>> {
    const { data } = await api.get<{
      data: ImpostoListItem[];
      meta: { total: number; pagina?: number; porPagina?: number };
    }>(BASE, { params: toGenexusParams(query) });
    return normalizeListEnvelope(data);
  },

  async get(id: number): Promise<ImpostoDto> {
    const { data } = await api.get<{ data: ImpostoDto }>(`${BASE}/${id}`);
    return data.data;
  },

  async create(input: ImpostoInput): Promise<ImpostoDto> {
    const { data } = await api.post<{ data: ImpostoDto }>(BASE, input);
    return data.data;
  },

  async update(id: number, input: ImpostoInput): Promise<ImpostoDto> {
    const { data } = await api.put<{ data: ImpostoDto }>(`${BASE}/${id}`, input);
    return data.data;
  },

  async remove(id: number): Promise<void> {
    await api.delete(`${BASE}/${id}`);
  },
};
